import { useQuery } from "@tanstack/react-query"
import { getTaskAssignmentsWithSchedules } from "@/api/timeAssignments/getTaskAssignmentsWithSchedules"

export const useGetTaskAssignmentsWithSchedules = (
  scheduleFrom: string,
  scheduleTo: string,
  refreshKey?: number
) => {
  return useQuery({
    queryKey: ['getTaskAssignmentsWithSchedules', scheduleFrom, scheduleTo, refreshKey],
    queryFn: () => getTaskAssignmentsWithSchedules({ scheduleFrom, scheduleTo }),
    staleTime: 1000 * 60 * 5, // 5 minutos
    gcTime: 1000 * 60 * 30, // 30 minutos en cache
    refetchOnMount: true,
    refetchOnWindowFocus: false, // Desactivar para evitar llamadas excesivas
    retry: (failureCount, error) => {
      console.log('🔄 Query retry attempt:', failureCount, error);
      // No reintentar para errores 404 o de red
      const axiosError = error as Error & { 
        response?: { status?: number }; 
        code?: string; 
      };
      if (axiosError?.response?.status === 404 || axiosError?.code === 'ERR_NETWORK') {
        return false;
      }
      return failureCount < 2;
    },
    retryDelay: 1000,
    // Configuración para evitar crashes
    throwOnError: false,
    refetchOnReconnect: true,
  })
}